<template>
  <div class="flex flex-row justify-center h-svh w-full">
    <NuxtLoadingIndicator />
    <div class="w-full border-x">
      <div class="flex flex-col min-h-svh justify-center">
        <div
          class="sticky top-0 z-50 flex justify-center shadow-md bg-stone-50 dark:bg-gray-300"
        >
          <div class="md:container px-2 w-full" v-if="!isNavDisabled">
            <V3NavbarComponent />
          </div>
        </div>
        <!-- <header class="bg-gray-300 z-40 text-white sticky top-0">
          <div class="md:container md:self-center mx-auto">
            <slot name="header"></slot>
          </div>
        </header> -->
        <main
          class="flex-grow md:container md:self-center"
          :class="{ 'mb-24': !(loansPage || financeApp || hasNoBottom), 'h-[calc(100svh-76px)]': financeApp }"
          :style="{ paddingBottom: footerHeight + 'px' }"
        >
          <div
            class="cursor-pointer"
            @click="scrollToTop"
            v-show="isVisible"
          >
          <div class="scrollToTop">
            <UIcon
              name="i-heroicons-arrow-up"
              class="text-white h-3 w-3"
            />
            <span>Back to Top</span>
            </div>
          </div>
          <!-- <div
            v-show="isVisible"
            class="w-full flex justify-center fixed z-50"
          >
            <div
              @click="scrollToTop"
              class="cursor-pointer text-center scrollToTop"
            >
              <UIcon
                name="i-heroicons-arrow-up"
                variant="solid"
                class="text-primary mTop h-5 w-5"
              />

              <p class="text-primary mTop h-5 w-5">Back to Top</p>
            </div>
          </div> -->
          <!-- NOTE: Not sure - this parent level keep alive here is'nt working.  -->
          <KeepAlive>
            <slot name="main" :class="{ 'mb-8': !(financeApp || hasNoBottom) }" />
          </KeepAlive>

          <V3PageLoaderComponent
            v-if="isLoading && showLoader"
            class="dark:text-black fixed top-0 left-0 w-full h-full flex items-center justify-center bg-white/80 z-50"
          />
        </main>
        <footer
          ref="footerRef"
          v-if="!route.meta.hideFooter"
          class="flex flex-col fixed bottom-0 w-full z-10 sm:shadow-2xl sm:p-4 sm:bg-gray-100 sm:border-t"
        >
          <slot name="footer"></slot>
          <!-- start: footer navigation for mobile view -->
          <div
            v-if="showFooterNavigation"
            class="sm:hidden w-full flex justify-between bg-white shadow-2xl shadow-black px-2 overflow-scroll"
          >
            <div
              v-for="item in navIcons.footerNavIcons"
              :key="item.name"
              @click="handleFooterClick(item.name)"
              class="min-w-14 w-full relative pt-2 px-2 py-2 cursor-pointer"
            >
              <div class="flex flex-col items-center justify-between">
                <div
                  v-if="isActiveFooterItem(item)"
                  class="absolute top-0 w-full h-[5px] bg-orange-500 rounded-b-xl"
                ></div>
                <div class="flex flex-col items-center justify-center pt-1">
                  <div>
                    <span
                      v-if="item.badge && item.badge > 0"
                      class="absolute top-2 right-4 bg-primary-600 text-white text-xs leading-3 rounded-full h-4 w-4 flex items-center justify-center"
                    >
                      {{ item.badge }}
                    </span>
                    <img
                      :src="
                        isActiveFooterItem(item) ? item.activeIcon : item.icon
                      "
                      :alt="item.label"
                      :title="item.label"
                      class="w-6 h-6"
                    />
                  </div>
                  <p
                    class="px-0.5 text-center text-xs leading-5 text-navyPrime w-16 truncate"
                    :class="{ 'text-primary-600': isActiveFooterItem(item) }"
                  >
                    {{ item.label }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- end: footer navigation for mobile view -->
        </footer>

        <USlideovers />
        <UModals />
      <LoginBanner
  :message="loginBannerMessage"
  :footer-height="footerHeight"
/>
        <UNotifications id="toast-notification-container"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import { V3PopupComponent } from "#components";
import { V3ModalComponent } from "#components";
import LoginBanner from '@/components/v4/LoginBanner.vue'
import { useLoginBanner } from '@/composables/useLoginBanner'
import { GoogleAnalytics } from "~/google_analytics/events";
import { EventParameter } from "~/google_analytics/events.enum";
const { loginBannerMessage } = useLoginBanner()
const route = useRoute();
const { isMobile } = useDevice();
const blacklist = ["location-finder",'loans'];
const isNavDisabled = blacklist.includes(route.name.toLowerCase());
const isVisible = ref(false);
const lastScrollPosition = ref(0);
const paths = [
  // "/providers",
  "/categories",
  "/categories/v2",
  "/deals",
  "/",
  "/collections/mahaKumbh",
  "/collections",
  "/categories/search",
  "/categories/search-v2",
];
const footerNavPreHandlers = [
  {
    routeName: "__all__",
    preHandlers: [
      () => {
        return route.query && route.query?.from !== "checkout";
      },
      () => {
        return route.path !== "/checkout";
      },
      // for routes like ocalhost:3001/order-summary
      () => {
        return route.path !== "/order-summary";
      },
      () => {
        return route.path !== "/select-location";
      },
    ],
  }, // Default handler to show footer navigation
];

const footerRef = ref(null);
const footerHeight = ref(0);
const updateFooterHeight = () => {
  if (footerRef.value) {
    footerHeight.value = footerRef.value.offsetHeight;
  }
};
const slideover = useSlideover();
const modal = useModal();
const navIcons = useNavIcons();
const { isLoading } = useLoadingIndicator();
const showLoader = computed(() => route.meta.showLoader ?? true);
const { gtag } = useGtag();
const auth = useAuth();
const isAuthenticated = auth && auth.access_token;
const userData = isAuthenticated
  ? {
    user_name: auth.user.first_name,
    user_phone: auth.user.phone,
    user_email: auth.user.email,
  }
  : {
    user_name: null,
    user_phone: null,
    user_email: null,
  };

onMounted(async () => {
  navIcons.getFooterNavIcons();

  // This is vital for dynamic content in the footer slot
  updateFooterHeight();
  window.addEventListener("resize", updateFooterHeight);

  const handleScroll = () => {
    const currentScrollPosition =
      window.pageYOffset || document.documentElement.scrollTop;

    if (
      currentScrollPosition > 0 &&
      route.path.startsWith("/providers") &&
      !isMobile
    ) {
      isVisible.value = true;
    } else {
      if (currentScrollPosition > 0 && paths.includes(route.path)) {
        isVisible.value = true;
      } else {
        isVisible.value = false;
      }
    }

    lastScrollPosition.value = currentScrollPosition;
  };

  window.addEventListener("scroll", handleScroll);

  handleScroll();

  onUnmounted(() => {
    window.removeEventListener("scroll", handleScroll);
  });
});

const scrollToTop = () => {
  gtag("event", "cta_event", {
    action: "click",
    cta_name: "back to top",
    lastScrollPosition: lastScrollPosition,
    ...userData,
  });
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const financeApp = ['finance-app-dashboard'].includes(route.name.toLowerCase());
const loansPage = ["loans"].includes(route.name.toLowerCase());
const hasNoBottom = computed(() =>
  ["index", "collections-rebelfoods"].includes(route.name.toLowerCase())
);

useBackButtonDetection((direction, path) => {
  if (direction === "back") {
    GoogleAnalytics.cta({
      [EventParameter.CTA_NAME]: "default back",
    })
  }
});

const cart = useCart();
const cartItemCount = computed(() => {
  return cart.itemCount;
});

const showFooterNavigation = computed(() => {
  // check for default pre-handlers first
  const defaultFooterRoutePreHandler =
    footerNavPreHandlers.find((handler) => handler.routeName === "__all__") ||
    {};
  const defaultPreHandlers = defaultFooterRoutePreHandler.preHandlers || [];
  const shouldShowDefault = defaultPreHandlers.every((handler) => handler());
  if (!shouldShowDefault) {
    return false;
  }
  // Check if the current route has specific pre-handlers
  const routeName = route.name;
  const footerRoutePreHandler =
    footerNavPreHandlers.find((handler) => handler.routeName === routeName) ||
    {};
  const preHandlers = footerRoutePreHandler.preHandlers || [];
  const shouldShow = preHandlers.every((handler) => handler() !== false);
  return shouldShow;
});

const isActiveFooterItem = (item) => {
  return route.path === item.name;
};
const handleFooterClick = async (routeName) => {
  // gtag('event', 'cta_event', {
  //   action: 'click',
  //   cta_name: `footer ${path}`,
  //   ...userData,
  // });
  let routes = [
    "/account/orders",
    // "/cart",
    "/menu",
    "/select-location",
    "/account/tickets",
    "/account/profile",
    "/support/raise_a_request",
  ];
  if (isAuthenticated == null && routes.includes(routeName)) {
    if (isMobile) {
      slideover.open(V3PopupComponent, {
        component: "login",
        closable: true,
        onSuccess: () => {
          useSSOAuth(routeName);
        },
        onClose: slideover.close,
      });
    } else {
      modal.open(V3ModalComponent, {
        component: "login",
        closable: true,
        onSuccess: () => {
          useSSOAuth(routeName);
        },
        onClose: modal.close,
      });
    }
    return;
  } else {
    await navigateTo({ path: routeName });
  }
};

onUpdated(() => {
  // This is vital for dynamic content in the footer slot
  updateFooterHeight();
});

onUnmounted(() => {
  window.removeEventListener("resize", updateFooterHeight);
});
</script>

<style>
.scrollToTop {
  border: solid;
  border-color: #002953;
  background-color: #002953;
  color: white;
  border-radius: 50px;
  width: 100px;
  z-index: 50;
  bottom: 80px;
  right: 20px;
  position: fixed;
  font-size: 12px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

/* .scrollToTop {
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 50;
  background-color: rgba(
    147,
    51,
    234,
    0.5
  ); 
  border-radius: 50%;
  padding: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
} */
.mTop {
  margin-top: 2px;
}
</style>
